<script lang="ts">
  import { onMount, createEventDispatcher } from 'svelte';

  export let name: string, filter: string;

  const dispatch = createEventDispatcher<{ filterValueInit: never }>();

  const handlePopstate = () => {
    const url = new URL(window.location.href);
    filter = url.searchParams.get(name) || '';
  };

  const synchronizeFilter = (isInitial: boolean) => {
    const url = new URL(window.location.href);
    const urlFilter = url.searchParams.get(name) || '';

    if (isInitial) {
      filter = urlFilter || filter;
      return;
    }
    if (typeof filter !== 'string') {
      filter = '';
    }

    if (filter === '' && urlFilter !== '') {
      url.searchParams.delete(name);
      window.history.pushState({}, '', url);
    } else if (urlFilter !== filter) {
      url.searchParams.set(name, filter);
      window.history.pushState({}, '', url);
    }
  };

  synchronizeFilter(true);

  onMount(() => dispatch('filterValueInit'));

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  $: name, filter, synchronizeFilter(false);
</script>

<svelte:window on:popstate={handlePopstate} />
